import { render } from "./BookACallButton.vue?vue&type=template&id=6b8a30a7&scoped=true"
import script from "./BookACallButton.vue?vue&type=script&lang=js"
export * from "./BookACallButton.vue?vue&type=script&lang=js"

import "./BookACallButton.vue?vue&type=style&index=0&id=6b8a30a7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8a30a7"]])

export default __exports__